module.exports = __webpack_public_path__ + "img/download-mockup@2x.8e7417a2.png";